import { PayrollValueObjectsConceptUnitTypeEnum } from 'generated/resources/graphql'

const UNITS = {
  distance: 'km',
  money: 'EUR',
  time: 'mins',
  unit: 'units',
} as const satisfies Record<PayrollValueObjectsConceptUnitTypeEnum, string>

// This is a workaround until we support dynamic units. We need to provide a way from the server to know the units of a concept.
const usePayrollConceptCompensationUnits = (unit: PayrollValueObjectsConceptUnitTypeEnum) => {
  return UNITS[unit]
}

type UsePayrollConceptCompensationUnits = ReturnType<typeof usePayrollConceptCompensationUnits>

export { usePayrollConceptCompensationUnits, UNITS }
export type { UsePayrollConceptCompensationUnits }
